<template>
  <form @submit.prevent class="info-form-area form_style">

    <div class="info-form form-slide-active" v-if="results">

      <div class="heading-area">
        <span class="icon-holder">
          <i class="icon-parking"></i>
        </span>
        <span class="text">
          {{ results.length }}
          {{ results.airportparking && results.airportparking.length || 0 }}
          {{ $t('airportparking.results.filters.car_parks') }}
          <br />
          {{ $t('airportparking.results.filters.quoted') }}
        </span>
      </div>

      <span class="btn-hold">
        <a nohref class="arrow-opener tablet-search collapsed" @click="search">
          <span class="text">
            {{ mobile ? $t('airportparking.results.filters.edit') : $t('airportparking.results.filters.search') }}
          </span>
          <span class="arrow">
            <i class="icon-arrow_down"></i>
          </span>
        </a>
      </span>

      <div class="input-slide collapse" :class="{'show' : mobileSearch }" id="collapseExample" v-if="value">
        <div class="slide-wrap">
          <input-date-time v-model="value" :label="$t('airportparking.results.filters.drop_off_label')" timeProp="timeA" dateProp="dateA" />
          <input-date-time :min-date="value.dateA" v-model="value" :label="$t('airportparking.results.filters.pick_up_label')" timeProp="timeB" dateProp="dateB"/>
          <button class="btn btn-primary d-md-none mobile-search" @click="forceSearch" type="button">{{ $t('airportparking.results.filters.search_again') }}</button>
        </div>
      </div>
    </div>

    <div class="filter_holder" v-if="results && results.airportparking && results.airportparking.length > 0">
      <span class="slide_opener d-md-none">
        <a
          class="filter-open"
          :class="{ 'active' : mobileFilters }"
          nohref
          @click="mobileFilters = !mobileFilters"
        >
          {{ $t('airportparking.results.filters.show') }}
        </a>
      </span>

      <div class="option-slide collapse" :class="{'show' : mobileFilters }" id="collapseExample2">
        <div class="option-holder">
          <strong class="title-filter">{{ $t('airportparking.results.filters.filter_by') }}</strong>
          <ul class="filter-list">
            <li v-for="(option, key) in types" :key="key">
              <a
                :class="{ 'active' : type === option.value }"
                nohref
                @click="type = option.value">{{ option.text }}</a>
            </li>
          </ul>
        </div>

        <div class="option-holder">
          <!-- Terminal filters -->
          <template v-if="terminals">
            <strong class="title-filter">{{ $t('airportparking.results.filters.terminal') }}</strong>
            <ul class="filter-list">
              <li>
                <a :class="{ 'active' : terminal === false }" nohref @click="terminal = false">
                  {{ $t('airportparking.results.type.all') }}
                </a>
              </li>
              <li v-for="(option, key) in terminals.split(',')" :key="key">
                <a
                    :class="{ 'active' : terminal === option }"
                    nohref
                    @click="terminal = option">{{ terminalShorten(option) }}</a>
              </li>
            </ul>
          </template>

          <!-- Map View filter -->
          <a nohref :class="{ 'active' : map }"  @click="showMap" class="map-view">
            {{ $t('airportparking.results.filters.map') }}
          </a>
        </div>
      </div>

      <div class="select-holder">
        <strong class="title-filter">{{ $t('airportparking.results.filters.order') }}</strong>
        <div class="select-wrap">
          <span class="fake-select">
            <select id="select-1" v-model="sort">
              <option
                v-for="(option, key) in orders"
                :key="key"
                :selected="sort === option.value"
                :value="option.value">{{ option.text }}</option>
            </select>
          </span>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { sync, get } from "vuex-pathify";
import { eventBus } from "@/eventBus";
import { InputDateTime } from "@/components";
import mixins from "@/mixins";

export default {
  name: "parking-filters",
  components: { InputDateTime },
  mixins: [mixins.format],
  data() {
    return {
      mobileFilters: false,
      mobileSearch: false,
      mobile: false,
      orders: [
        { text: this.$t('airportparking.results.sort.recommended'), value: 'recommended' },
        { text: this.$t('airportparking.results.sort.price_low'), value: 'price-low' },
        { text: this.$t('airportparking.results.sort.price_high'), value: 'price-high' }
      ],
      types: [
        { text: this.$t('airportparking.results.type.all'), value: false },
        { text: this.$t('airportparking.results.type.on'), value: 'On' },
        { text: this.$t('airportparking.results.type.off'), value: 'Off' },
        { text: this.$t('airportparking.results.type.meet_greet'), value: 'Chauffeur' },
      ],
      dateChanged: 0
    }
  },
  computed: {
    ...sync("filters/*"),
    results: get("results/products"),
    terminals: get("results/airport@terminals"),
    quote: get("quote")
  },
  props: {
    value: { type: Object },
  },
  mounted() {
    this.windowSize()
    window.addEventListener("resize", this.windowSize)
    this.terminal = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.windowSize);
  },
  methods: {
    search(e) {
      e.preventDefault();
      this.mobile ? (this.mobileSearch = !this.mobileSearch) : eventBus.$emit("SEARCH");
    },
    forceSearch(e) {
      e.preventDefault();
      eventBus.$emit("SEARCH");
    },
    windowSize() {
      this.mobile =  document.documentElement.clientWidth < 767
    },
    showMap() {
      this.map = !this.map;
      let mapHolder = document.getElementsByClassName('main-area')[0]
      if(this.map) mapHolder.scrollIntoView()
    }
  }
};
</script>
